import { g as getRootDomain, s as setCookieValue, p as parseCookies } from "../../../cookies-04bd2321.js";
import { logger } from "../../../utils/logger.es.js";
import { w as waitFor } from "../../../waitFor-1b67bbb8.js";
const merkleCallback = (resolve) => {
  const cookies = parseCookies();
  const merkleData = window._svDataLayer;
  let finalData;
  if (merkleData === void 0) {
    finalData = {};
    if ((cookies == null ? void 0 : cookies.eh_merkury_confidence_score) === "" || (cookies == null ? void 0 : cookies.eh_merkury_confidence_score)) {
      finalData.merkury_confidence_score = cookies.eh_merkury_confidence_score;
    }
    if ((cookies == null ? void 0 : cookies.eh_merkury_cmid) === "" || (cookies == null ? void 0 : cookies.eh_merkury_cmid)) {
      finalData.merkury_cmid = cookies.eh_merkury_cmid;
    }
    if ((cookies == null ? void 0 : cookies.eh_merkury_hmid) === "" || (cookies == null ? void 0 : cookies.eh_merkury_hmid)) {
      finalData.merkury_hmid = cookies.eh_merkury_hmid;
    }
    setMerkleCookies(finalData);
    resolve(finalData);
  } else if (Object.keys(merkleData).length === 0) {
    finalData = {};
    if ((cookies == null ? void 0 : cookies.eh_merkury_confidence_score) || (cookies == null ? void 0 : cookies.eh_merkury_cmid) || (cookies == null ? void 0 : cookies.eh_merkury_hmid)) {
      logger.warn("Found cookies but no Merkle Data");
    }
    if (cookies == null ? void 0 : cookies.eh_merkury_confidence_score) {
      finalData.merkury_confidence_score = cookies.eh_merkury_confidence_score;
    } else {
      finalData.merkury_confidence_score = "";
    }
    if (cookies == null ? void 0 : cookies.eh_merkury_cmid) {
      finalData.merkury_cmid = cookies.eh_merkury_cmid;
    } else {
      finalData.merkury_cmid = "";
    }
    if (cookies == null ? void 0 : cookies.eh_merkury_hmid) {
      finalData.merkury_hmid = cookies.eh_merkury_hmid;
    } else {
      finalData.merkury_hmid = "";
    }
    setMerkleCookies(finalData);
    resolve(finalData);
  } else {
    finalData = {
      merkury_confidence_score: merkleData.confidence_score !== void 0 ? merkleData.confidence_score : (cookies == null ? void 0 : cookies.eh_merkury_confidence_score) !== void 0 ? cookies.eh_merkury_confidence_score : "",
      merkury_cmid: merkleData.merkury_id_cmid !== void 0 ? merkleData.merkury_id_cmid : (cookies == null ? void 0 : cookies.eh_merkury_cmid) !== void 0 ? cookies.eh_merkury_cmid : "",
      merkury_hmid: merkleData.merkury_id_hmid !== void 0 ? merkleData.merkury_id_hmid : (cookies == null ? void 0 : cookies.eh_merkury_hmid) !== void 0 ? cookies.eh_merkury_hmid : ""
    };
    setMerkleCookies(finalData);
    resolve(finalData);
  }
};
const getMerkleIds = () => {
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    waitFor(
      () => window._svDataLayer,
      () => merkleCallback(resolve),
      () => merkleCallback(resolve),
      0,
      5,
      50
    );
  });
};
const setMerkleCookies = (merkleData) => {
  const rootDomain = getRootDomain(window.location.hostname);
  const cookieOptions = {
    domain: rootDomain,
    httpOnly: false,
    path: "/"
  };
  setCookieValue(
    "eh_merkury_confidence_score",
    merkleData.merkury_confidence_score || "",
    cookieOptions
  );
  setCookieValue(
    "eh_merkury_cmid",
    merkleData.merkury_cmid || "",
    cookieOptions
  );
  setCookieValue(
    "eh_merkury_hmid",
    merkleData.merkury_hmid || "",
    cookieOptions
  );
};
export {
  getMerkleIds,
  setMerkleCookies
};
